<div class="container-login100">
  <div class="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-54">
    <form class="login100-form validate-form"  [formGroup]="checkoutForm" (ngSubmit)="onSubmit(checkoutForm.value)" >
        <nz-tabset [nzAnimated]="false" class="tabs" (nzSelectChange)="switch($event)">
            <nz-tab [nzTitle]="'手机号找回'">

                <nz-alert *ngIf="error" [nzType]="nzType"  [nzMessage]="error" [nzShowIcon]="true" class="mb-lg"></nz-alert> 

                <div class="wrap-input100 validate-input m-b-23" data-validate="请输入注册手机号">
                  <span class="label-input100">{{"手机号"|translate}}</span>
                  <input class="input100" type="number" formControlName="phone" placeholder="请输入注册手机号" autocomplete="off">
                  <span class="focus-input100" data-symbol=""></span>
                </div>

                <div class="wrap-input100 validate-input m-b-23" data-validate="请输入手机验证码">
                    <span class="label-input100">{{"验证码"|translate}}</span>
                    <input class="input100" type="text" formControlName="code" placeholder="请输入手机验证码" autocomplete="off">
                                        <!-- 获取验证码 -->
                    <button class="codebtn" type="button" nz-button nzSize="large" (click)="getCaptcha()" [disabled]="count>0" nzBlock>
                        {{ count ? count + 's' : '获取验证码'  }}
                    </button>
                    <span class="focus-input100" data-symbol=""></span>
                </div>

                <div class="wrap-input100 validate-input m-b-23" data-validate="请输入新密码">
                  <span class="label-input100">{{"新密码"|translate}}</span>
                  <input class="input100" type="password" formControlName="password" placeholder="请输入新密码">
                  <span class="focus-input100" data-symbol=""></span>
                </div>

                <div class="wrap-input100 validate-input" data-validate="请输入确认密码">
                    <span class="label-input100">{{"确认密码"|translate}}</span>
                    <input class="input100" type="password" formControlName="newpassword" placeholder="请输入确认密码">
                    <span class="focus-input100" data-symbol=""></span>
                  </div>
            </nz-tab>
            <nz-tab [nzTitle]="'邮箱找回'">

                <nz-alert *ngIf="error" [nzType]="'error'" [nzMessage]="error" [nzShowIcon]="true" class="mb-lg"></nz-alert> 

                <div class="wrap-input100 validate-input m-b-23" data-validate="请输入注册邮箱">
                  <span class="label-input100">{{"邮箱"|translate}}</span>
                  <input class="input100" type="email" formControlName="email" placeholder="请输入注册邮箱" autocomplete="off">
                  <span class="focus-input100" data-symbol=""></span>
                </div>

                <div class="wrap-input100 validate-input m-b-23" data-validate="请输入邮箱验证码">
                    <span class="label-input100">{{"验证码"|translate}}</span>
                    <input class="input100" type="text" formControlName="code" placeholder="请输入邮箱验证码" autocomplete="off">
                    <span class="focus-input100" data-symbol=""></span>

                  </div>

                  <div class="wrap-input100 validate-input m-b-23" data-validate="请输入新密码">
                    <span class="label-input100">{{"新密码"|translate}}</span>
                    <input class="input100" type="password" formControlName="password" placeholder="请输入新密码">
                    <span class="focus-input100" data-symbol=""></span>
                  </div>

                  <div class="wrap-input100 validate-input" data-validate="请输入确认密码">
                      <span class="label-input100">{{"确认密码"|translate}}</span>
                      <input class="input100" type="password" formControlName="newpassword" placeholder="请输入确认密码">
                      <span class="focus-input100" data-symbol=""></span>
                    </div>
            </nz-tab>
          </nz-tabset>

      <div class="text-right p-t-8 p-b-31">
      </div>

      <div class="container-login100-form-btn">
        <div class="wrap-login100-form-btn">
          <div class="login100-form-bgbtn"></div>

          <button  nz-button type="submit" nzType="primary"  class="login100-form-btn" [nzLoading]="http.loading">{{"提 交"|translate}}</button>
        </div>
      </div>
      <div class="flex-col-c p-t-25">
        <input type="button" />
      </div>
    </form>
  </div>
</div>
